module.exports = __webpack_public_path__ + "img/padaria.37d24459.png";